import * as React from 'react';
import { useMemo } from 'react';
import * as Immutable from 'immutable';

import type FieldTypeMapping from 'views/logic/fieldtypes/FieldTypeMapping';
import useFieldTypes from 'data-lake/hooks/useFieldTypes';
import FieldTypesContext from 'views/components/contexts/FieldTypesContext';

const FieldTypesProvider = ({ children }: React.PropsWithChildren) => {
  const { data: fieldTypes } = useFieldTypes();
  const fieldTypesContextValue = useMemo(
    () => ({
      all: Immutable.List(fieldTypes) ?? Immutable.List(),
      currentQuery: Immutable.List<FieldTypeMapping>(),
    }),
    [fieldTypes],
  );

  return <FieldTypesContext.Provider value={fieldTypesContextValue}>{children}</FieldTypesContext.Provider>;
};

export default FieldTypesProvider;
